import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FiCheckCircle, FiXCircle, FiMessageSquare } from 'react-icons/fi';
import './TakeActionDialog.css';

const TakeActionDialog = ({ show, onHide, notification, onResolve, onDismiss }) => {
  const { t } = useTranslation();
  const [resolutionDetails, setResolutionDetails] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleResolve = async () => {
    if (!resolutionDetails.trim()) {
      alert(t('notifications.resolutionDetailsRequired'));
      return;
    }

    setIsSubmitting(true);
    try {
      await onResolve(notification, resolutionDetails);
      setResolutionDetails('');
      onHide();
    } catch (error) {
      console.error('Error resolving notification:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDismiss = async () => {
    setIsSubmitting(true);
    try {
      await onDismiss(notification);
      onHide();
    } catch (error) {
      console.error('Error dismissing notification:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!notification) return null;

  return (
    <Modal show={show} onHide={onHide} centered size="md">
      <Modal.Header closeButton>
        <Modal.Title>
          <FiMessageSquare className="me-2" />
          {t('notifications.takeAction')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="notification-info mb-3">
          <h6>{notification.title}</h6>
          <p className="text-muted small mb-2">{notification.description}</p>
          <div className="d-flex gap-2">
            <span className={`badge bg-${notification.severity === 'high' ? 'danger' : notification.severity === 'medium' ? 'warning' : 'info'}`}>
              {t(`notifications.severity.${notification.severity}`)}
            </span>
            <span className="badge bg-secondary">
              {t(`notifications.types.${notification.type}`)}
            </span>
          </div>
        </div>

        <Form.Group className="mb-3">
          <Form.Label>{t('notifications.resolutionDetails')}</Form.Label>
          <Form.Control
            as="textarea"
            rows={4}
            value={resolutionDetails}
            onChange={(e) => setResolutionDetails(e.target.value)}
            placeholder={t('notifications.resolutionDetailsPlaceholder')}
            disabled={isSubmitting}
          />
          <Form.Text className="text-muted">
            {t('notifications.resolutionDetailsHelp')}
          </Form.Text>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={handleDismiss}
          disabled={isSubmitting}
        >
          <FiXCircle className="me-1" />
          {t('notifications.dismiss')}
        </Button>
        <Button
          variant="success"
          onClick={handleResolve}
          disabled={isSubmitting || !resolutionDetails.trim()}
        >
          <FiCheckCircle className="me-1" />
          {isSubmitting ? t('common.submitting') : t('notifications.resolve')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TakeActionDialog;